@if (policy) {
  <policy-view
    #policyViewComponent
    data="{{ data }}"
    userexpdata="{{ policy }}"
    (ctaEvent)="onCtaClicked($event)"
  ></policy-view>
}
